<template>
     <g :id="station.id" class='metro-station' :class="{ selected: selected, 'has-info': station.info, off: station.state == 'off' }" @click="click" :transform="translate" >
        <circle v-if="!station.lines || station.lines.length == 1" />
        <rect v-else />
        <text v-if="station.info" class="i">i</text>
       
        <text>{{ station.name }}</text>
        <g v-if="station.status == 'error' || station.status == 'warning'" class='alert' :class='station.status' transform="translate(-16 30)">
            <path d="M13.901923788647 3.4785300299879a3 3 0 0 1 5.1961524227066 0l13.303847577293 23.042939940024a3 3 0 0 1 -2.5980762113533 4.5l-26.607695154587 0a3 3 0 0 1 -2.5980762113533 -4.5"></path>
            <text>!</text>
        </g>

        <!--rect v-if="station.state == 'off'" class="off" /-->

     </g>

</template>

<script>
export default ({
    props: ['station', 'selected', 't'],
    data: function() {
        return { 
            
        }
    },
    computed: {
       translate(){
            return this.t ? "translate(" + this.t + ")" : "";
       }
    },
    methods: {
       
        click(){
            this.$emit('click', this.station.id);
        }
    }

 })
</script>